import { NavLink } from "react-router-dom";
import { Channel } from "src/models";

export const TvChannelCard: React.FC<Channel> = ({ slug, thumbnail, logo, title }) => (
    <div className="channel-category-list">
        <NavLink to={`/tv/${slug}`} activeClassName="router-link-exact-active"
            className="channel-item-header text-rtl text-right text-rtl">
            <div className="channel-item-header-content">
                <div style={{ backgroundImage: `url(${thumbnail})` }} className="channel-thumbnail" />
                <div style={{ backgroundImage: `url(${logo})` }} className="channel-logo" />
                <h1>{title}</h1>
            </div>
        </NavLink>
    </div>
);